// Cookie Consent Management
window.acceptCookies = function() {
  localStorage.setItem('cookieConsent', 'accepted');
  document.getElementById('cookieConsent').classList.add('d-none');
  if (typeof initializeAnalytics === 'function') {
    initializeAnalytics();
  }
};

window.declineCookies = function() {
  localStorage.setItem('cookieConsent', 'declined');
  document.getElementById('cookieConsent').classList.add('d-none');
};

function checkCookieConsent() {
  var consent = localStorage.getItem('cookieConsent');

  if (!consent) {
    var banner = document.getElementById('cookieConsent');
    if (banner) {
      banner.classList.remove('d-none');
    }
  } else if (consent === 'accepted' && typeof initializeAnalytics === 'function') {
    initializeAnalytics();
  }
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', checkCookieConsent);
} else {
  checkCookieConsent();
}